import { createStore } from 'vuex'
// 引入插件
import createPersistedState from "vuex-persistedstate"

export default createStore({
  state: {
    access_token: '',
  },
  getters: {
  },
  mutations: {
    setUserInfo(state, data) {
      state.access_token = data;
    }
  },
  actions: {
    setUserInfo(context, data) {
      context.commit("setUserInfo", data)
    }
  },
  modules: {
  },
  /* vuex数据持久化配置 */
  plugins: [
    createPersistedState({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.sessionStorage,
      // 存储的 key 的key值
      key: "store",
    })
  ]
})
